import React from 'react';
import { SavedPaypalPaymentForm } from 'Forms/SavedPaypalForm/SavedPaypalForm';
import { getPaypalPaymentMethodId } from 'Utils/PaymentMethods';
import { useStore } from 'Hooks/useStore';

export const PaypalPayment = ({ handleSavedPayment, submitButtonText, savedPaypalForm }) => {
  const paymentMethods = useStore('paymentMethods');
  const { paypalError } = useStore('checkout');
  const { selectedPlan } = useStore('plans');
  return paymentMethods.hasPaypalPayment ? (
    <SavedPaypalPaymentForm
      ref={savedPaypalForm}
      paymentMethod={paymentMethods.paypalPayment}
      onFormSubmit={() => handleSavedPayment(getPaypalPaymentMethodId(paymentMethods.paypalPayment))}
      submitButtonText={submitButtonText}
      selectedPlan={selectedPlan}
    />
  ) : (
    <div className="paypalCaptureError">
      <div className="formSubmitError">{paypalError}</div>
    </div>
  );
};
